// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PArrowUpOutlinedSvg from "@fishx/icons-svg/es/asn/PArrowUpOutlined";
import FishxIcon from '../components/FishxIcon';

var PArrowUpOutlined = function PArrowUpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PArrowUpOutlinedSvg
  }));
};

PArrowUpOutlined.displayName = 'PArrowUpOutlined';
export default React.forwardRef(PArrowUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PArrowUpOutlined.js
// module id = 3213
// module chunks = 0